import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { Vue } from 'vue-property-decorator';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';

import { ModuleContentTitleTrend } from '@/@types/graphql-types';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailStreamingChartListItem',
  props: {
    titleName: null,
    posterUrl: null,
    chartPosition: null,
    titleUrl: null,
    chartMovement: null,
    chartPositionDynamic: { default: ModuleContentTitleTrend.Stable },
    daysInTop1000: null,
    showSeason: { default: null },
    isTitle: { type: Boolean },
    title: null
  },
  setup(__props: any) {

const props = __props as { titleName: string, posterUrl: string, chartPosition?: number, titleUrl: string, chartMovement?: number, chartPositionDynamic: ModuleContentTitleTrend, daysInTop1000?: number, showSeason: number | null, isTitle?: boolean, title?: any };



const { tc } = useI18n();

const imgSrc = computed(
	() =>
		Vue.filter('Thumbor')({ url: props.posterUrl, imageType: 'poster' }) ?? '/appassets/img/poster-placeholder.png'
);

const formattedChartPosition = computed(() => {
	if (!props.chartPosition) return '';

	return props.chartPosition.toLocaleString('en-US', {
		minimumIntegerDigits: 2,
		useGrouping: false,
	});
});

const arrowClasses = computed(() => {
	if (!showArrow.value) {
		return null;
	}

	return {
		'streaming-chart-list-item__arrow': !!props.chartPositionDynamic,
		'streaming-chart-list-item__arrow--up': props.chartPositionDynamic === ModuleContentTitleTrend.Up,
		'streaming-chart-list-item__arrow--stable': props.chartPositionDynamic === ModuleContentTitleTrend.Stable,
		'streaming-chart-list-item__arrow--down': props.chartPositionDynamic === ModuleContentTitleTrend.Down,
	};
});

const showArrow = computed(() => props.chartPositionDynamic && !isNew.value);

const isNew = computed(() => {
	const isNewPosition = props.chartPosition == null || props.chartPosition <= 1000;
	return (
		(props.daysInTop1000 === 0 && isNewPosition) ||
		props.chartPositionDynamic === ModuleContentTitleTrend.New ||
		(props.chartMovement != null && props.chartMovement >= 5000)
	);
});

const seasonNumber = computed(() => `${tc('WEBAPP_SEASON')} ${props.showSeason}`);

const trendDifference = computed(() => {
	if (props.chartPositionDynamic === ModuleContentTitleTrend.Up) return `+${props.chartMovement}`;
	if (props.chartPositionDynamic === ModuleContentTitleTrend.Stable) return '—';
	if (props.chartPositionDynamic === ModuleContentTitleTrend.Down) return `${props.chartMovement}`;

	return '—';
});

return { __sfc: true,props, tc, imgSrc, formattedChartPosition, arrowClasses, showArrow, isNew, seasonNumber, trendDifference, PictureComp, TitleDetailLink }
}

})